import {
  addQueryParams,
  FlexRowCenterHorizontal,
  LoadingSpinner,
  useQueryParams,
  useRedirect,
} from '@main/core-ui';
import { DataSubject } from '@main/datamap-types';
import { ImmutableUrl } from '@main/immutable-url';
import { DataSubjectList } from '@main/pc-core-components';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { activeDataSubjectMessages } from './messages';
import { selectActiveDataSubject, selectDataSubjects } from './selectors';
import { setActiveDataSubject } from './slice';

/**
 * Select the current data subject
 */
export const ActiveDataSubject: React.FC<{
  /** Hide the UI */
  hide?: boolean;
}> = ({ hide }) => {
  const activeDataSubject = useSelector(selectActiveDataSubject);
  const subjects = useSelector(selectDataSubjects);
  const location = useLocation();
  const redirect = useRedirect();
  const dispatch = useDispatch();
  const { redirectTo: rawRedirectTo } = useQueryParams();

  // Only redirect to a URL on the privacy center
  const redirectTo =
    !rawRedirectTo || ImmutableUrl.isCompleteUrl(rawRedirectTo)
      ? addQueryParams(location, { modal: 'take-control' })
      : rawRedirectTo;

  useEffect(() => {
    if (!hide && subjects.length === 1) {
      redirect(
        subjects[0]?.disabledInstructions
          ? addQueryParams(location, { modal: 'take-control' })
          : redirectTo,
      );
    }
  }, [subjects]);

  // Don't show while we figure out UI TODO
  if (hide) {
    return <React.Fragment />;
  }

  // Backend has yet to respond
  if (!activeDataSubject) {
    return (
      <FlexRowCenterHorizontal>
        <LoadingSpinner />
      </FlexRowCenterHorizontal>
    );
  }

  return (
    <DataSubjectList
      headerMessage={activeDataSubjectMessages.header}
      value={subjects}
      activeDataSubjectId={activeDataSubject.id}
      onSelect={(subject: DataSubject) => {
        dispatch(setActiveDataSubject({ activeDataSubject: subject }));
        setTimeout(() => {
          redirect(
            subject?.disabledInstructions
              ? addQueryParams(location, { modal: 'take-control' })
              : redirectTo,
          );
        }, 250);
      }}
    />
  );
};

export default ActiveDataSubject;
